import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { formatDate } from 'App/components/PatientProfile/PatientProfile.utils.js';
import { dateOnlySlashesFormat, dateTimeSlashesFormat, formatUtcDate } from 'App/services/DateService';
import './PatientMetaDataStyles.scss';

const propTypes = {
    patientMetaData: PropTypes.shape({
        updatedOn: PropTypes.string,
        referralStatus: PropTypes.string,
        referralReason: PropTypes.string,
        referralUpdate: PropTypes.string,
        welcomePacket: PropTypes.bool,
        welcomePacketSent: PropTypes.string,
        welcomePacketReturned: PropTypes.string,
        updatedByUser: PropTypes.shape({
            cdcId: PropTypes.string,
            firstName: PropTypes.string,
            lastName: PropTypes.string,
        }),
    }),
};
const defaultProps = {
    patientMetaData: {},
};

function PatientMetaData({ patientMetaData }) {
    const {
        updatedOn,
        referralStatus,
        referralReason,
        referralUpdate,
        welcomePacket,
        welcomePacketSent,
        welcomePacketReturned,
        updatedByUser,
    } = patientMetaData;

    return (
        <div className="meta-data-section">
            <Row className="row-meta-data-section">
                <Col md={4}>
                    Last Updated By: {updatedByUser?.firstName} {updatedByUser?.lastName}
                    {updatedOn && (
                        <span data-testid="updated-on-date">{` on ${formatDate(updatedOn, dateTimeSlashesFormat)}`}</span>
                    )}
                </Col>
            </Row>
            {referralStatus && referralReason && referralUpdate && (
                <Row className="row-meta-data-section">
                    <Col md={4}>RSV Referral Status: {referralStatus}</Col>
                    <Col md={4}>RSV Referral Status Description: {referralReason}</Col>
                    <Col md={4}>RSV Referral Status Change Date: {referralUpdate}</Col>
                </Row>
            )}

            {welcomePacket && (
                <Row className="row-meta-data-section">
                    <Col md={4}>
                        <strong>Welcome Packet Requested</strong>
                    </Col>
                    <Col md={4}>
                        Mail Date: {formatUtcDate({ date: welcomePacketSent, format: dateOnlySlashesFormat })}
                    </Col>
                    <Col md={4}>
                        Return Date: {formatUtcDate({ date: welcomePacketReturned, format: dateOnlySlashesFormat })}
                    </Col>
                </Row>
            )}
        </div>
    );
}

PatientMetaData.propTypes = propTypes;
PatientMetaData.defaultProps = defaultProps;

export default PatientMetaData;
